<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加支付-->
      <div class="common-form">修改支付</div>
      <!-- 选择店铺 -->
      <!-- <el-form-item label="选择店铺 ">
        <el-select v-model="form.port_id" placeholder="请选择店铺" >
          <el-option v-for="(item,index) in list" :key="item.port_id" :label="item.port_name" :value="item.port_id">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="名称 " prop="name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="简介 " prop="introduce" >
        <el-input v-model="form.introduce" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="缩略图" :rules="[{required: true,message: '请输入上传缩略图'}]">
        <el-button @click="chooseImg">选择图片</el-button>
        <img class="mt10" v-img-url="form.file_url" width="200">
      </el-form-item>

      <!-- <el-form-item label="支付类型值" :rules="[{required: true,message: '请输入支付类型值'}]">
        <el-input-number v-model="form.value" :step="10" step-strictly :min="10"></el-input-number>
      </el-form-item> -->

      <el-form-item label="支付类型 ">

        <el-select v-model="form.payment_type" placeholder="请选择">
          <el-option v-for="(item,index) in payment_arr" :key="index" :label="item" :value="index">
          </el-option>
        </el-select>
        <div class="tips"> 目前支持 微信支付、支付宝支付和汇付</div>
      </el-form-item>


      <!-- 支付宝支付 -->
      <div v-if="form.payment_type=='40-alipay_app' || form.payment_type=='40-alipay_h5'">
        <el-form-item label="支付宝 appid"  prop="alipay.appid" :rules="[{required: true,message: ' '}]">
          <el-input v-model="form.alipay.appid" class="max-w460"></el-input>
          <div class="tips"></div>
        </el-form-item>

        <el-form-item label="支付宝公钥">
          <el-input type="textarea" :rows="4" v-model="form.alipay.publicKey" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="应用私钥">
          <el-input type="textarea" :rows="4" v-model="form.alipay.privateKey" class="max-w460"></el-input>
        </el-form-item>
      </div>

      <!-- 微信支付 -->
      <div v-if="form.payment_type=='20-wx_mn' || form.payment_type=='20-wx_mp' || form.payment_type=='20-wx_app'">
        <el-form-item label="微信支付商户号 MCHID">
          <el-input v-model="form.wechatpay.mchid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="微信支付密钥 APIKEY ">
          <el-input v-model.trim="form.wechatpay.apikey" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="微信appid" v-if="form.payment_type=='20-h5' || form.payment_type=='20-wx'">
          <el-input v-model.trim="form.wechatpay.wxapp_id" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="微信appid" v-if="form.payment_type=='20-app'">
          <el-input v-model.trim="form.wechatpay.app_id" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="apiclient_cert.pem">
          <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model.trim="form.wechatpay.cert_pem" class="max-w460"></el-input>
          <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
        </el-form-item>
        <el-form-item label="apiclient_key.pem">
          <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model.trim="form.wechatpay.key_pem" class="max-w460"></el-input>
          <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
        </el-form-item>
      </div>

      <!-- 银联支付 -->
      <div v-if="form.payment_type=='unionpay'">
        <el-form-item label="商户号(mid)">
          <el-input v-model="form.unionpay.mid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="终端号(tid)">
          <el-input v-model="form.unionpay.tid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="机构商户号(instMid)">
          <el-input v-model="form.unionpay.instMid" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="消息来源(msgSrc)">
          <el-input v-model="form.unionpay.msgSrc" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="来源编号（msgSrcId）">
          <el-input v-model="form.unionpay.msgSrcId" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="通讯秘钥 ">
          <el-input v-model="form.unionpay.Key" class="max-w460"></el-input>
        </el-form-item>
      </div>

      <!-- 汇付支付宝h5 -->
      <div v-if="['60-huifu_alipay_h5', '60-huifu_wxmp', '60-huifu_alipay_app','60-huifu_wxmn'].indexOf(form.payment_type) > -1">
        <el-form-item label="汇付appid" prop="adapay.app_id" :rules="[{required: true,message: '请输入汇付appid'}]">
          <el-input v-model="form.adapay.app_id" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="汇付支付渠道" prop="adapay.pay_channel" :rules="[{required: true,message: '请输入汇付支付渠道'}]">
          <el-input v-model="form.adapay.pay_channel" class="max-w460"></el-input>
        </el-form-item>
      </div>

       <!-- 康采余额支付 -->
      
       <div v-if="form.payment_type=='100-ini'">
        <el-form-item label="支付网址">
          <el-input v-model="form.ini.website" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="账户">
          <el-input v-model="form.ini.app_id" class="max-w460"></el-input>
        </el-form-item>
  
        <el-form-item label="通讯ID">
          <el-input v-model="form.ini.api_app_id" class="max-w460"></el-input>
        </el-form-item>
  
        <el-form-item label="通讯秘钥">
          <el-input v-model="form.ini.key" class="max-w460"></el-input>
        </el-form-item>

      </div>

      <el-form-item label="备注">
        <el-input type="textarea" :rows="4" v-model="form.remark" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="是否支持收款">
        <div>
          <el-radio v-model="form.pay_open" :label="1">是</el-radio>
          <el-radio v-model="form.pay_open" :label="0">否</el-radio>
        </div>
      </el-form-item>

      <el-form-item label="是否支持退款">
        <div>
          <el-radio v-model="form.refund_open" :label="1">是</el-radio>
          <el-radio v-model="form.refund_open" :label="0">否</el-radio>
        </div>
      </el-form-item>

      <el-form-item label="是否支持转账">
        <div>
          <el-radio v-model="form.transfer_open" :label="1">是</el-radio>
          <el-radio v-model="form.transfer_open" :label="0">否</el-radio>
        </div>
      </el-form-item>

      <el-form-item label="是否启用">
        <div>
          <el-radio v-model="form.status" :label="1">是</el-radio>
          <el-radio v-model="form.status" :label="0">否</el-radio>
        </div>
      </el-form-item>

      <el-form-item label="排序">
        <el-input v-model="form.sort" type="number" class="max-w460"></el-input>
        <div class="tips">数字越小越靠前</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" style="background: #999;border: 1px solid #999;" @click="getToBack" :loading="loading">返回上一页</el-button>
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 3 }" @returnImgs="returnImgsFunc"></Upload>

  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  import Upload from '@/components/file/Upload';
  export default {
    components:{
      Upload
    },
    data() {
      return {
        /*form表单数据*/
        form: {
          port_id: 0,
          name: '',
          introduce: '',
          payment_type: '',
          label: '',
          sort: 1,
          file_id: 0,
          file_url: '',
          status: 0,
          remark: '',
          pay_open: 0,
          refund_open: 0,
          transfer_open: 0,
          value: '', // 支付类型值
          alipay: {
            appid: '',
            publicKey: '',
            privateKey: '',
          },
          wechatpay: {
            mchid: '',
            apikey: '',
            cert_pem: '',
            key_pem: '',
            wxapp_id: '',
            app_id: ''
          },
          unionpay:{
            mid: '',
            tid: '',
            instMid: '',
            msgSrc: '',
            msgSrcId: '',
            Key: ''
          },
          adapay:{
            app_id: '',
            pay_channel: ''
          },
          ini:{
            website:"",
            app_id: '',
            api_app_id:"",
            key:""
            
          }
        },
        list: [],
        loading: false,
        // payment_arr: {
        //   balance: '余额支付',
        //   alipay: '支付宝支付',
        //   wechatpay: '微信支付',
        //   unionpay: '银联支付',
        // }
        payment_arr: {
          "10-balance": "余额",
          "20-wx_mn": "微信h5",
          "20-wx_mp": "微信小程序",
          "20-wx_app": "微信app",
          "40-alipay_h5": "支付宝h5",
          "40-alipay_app": "支付宝app",
          "60-huifu_alipay_h5": "汇付支付宝h5",
          "60-huifu_alipay_app": "汇付支付宝app",
          "60-huifu_wxmn": "汇付微信公众号",
          "60-huifu_wxmp": "汇付微信小程序",
          "100-ini":"互联互通"
        },
        isupload: false
      };
    },

    created() {
      this.getData();
    },

    methods: {
      getToBack() {
        this.$router.go(-1)
      },
      getData() {
        let self = this;
        // 取到路由带过来的参数
        const params = this.$route.query.payment_id
        SettingApi.paymentDetail({
            payment_id: params
          }, true)
          .then(data => {
            let detail = data.data.detail;
            this.form.payment_id = detail.payment_id;
            this.form.port_id = detail.port_id;
            this.form.name = detail.name;
            this.form.introduce = detail.introduce;
            this.form.payment_type = detail.value + "-" + detail.label;
            this.form.sort = detail.sort;
            this.form.file_id = detail.file_id;
            this.form.file_url = detail.file_url;
            this.form.status = detail.status;
            this.form.remark = detail.remark;
            this.form.pay_open = detail.pay_open;
            this.form.refund_open = detail.refund_open;
            this.form.transfer_open = detail.transfer_open;
            this.form.value = detail.value;
            this.list = data.data.list.data;

            if (this.form.payment_type == '40-alipay_h5' || this.form.payment_type == '40-alipay_app') {
              this.form.alipay.appid = detail.setting.appid;
              this.form.alipay.publicKey = detail.setting.publicKey;
              this.form.alipay.privateKey = detail.setting.privateKey;
            }
            if (this.form.payment_type == '20-w_xmn' || this.form.payment_type == '20-wx_mp' || this.form.payment_type == '20-wx_app') {
              this.form.wechatpay.mchid = detail.setting.mchid;
              this.form.wechatpay.apikey = detail.setting.apikey;
              this.form.wechatpay.wxapp_id = detail.setting.wxapp_id;
              this.form.wechatpay.app_id = detail.setting.app_id;
              this.form.wechatpay.cert_pem = detail.setting.cert_pem;
              this.form.wechatpay.key_pem = detail.setting.key_pem;
            }
            if (this.form.label == 'unionpay') {
              this.form.unionpay.mid = detail.setting.mid;
              this.form.unionpay.tid = detail.setting.tid;
              this.form.unionpay.instMid = detail.setting.instMid;
              this.form.unionpay.msgSrc = detail.setting.msgSrc;
              this.form.unionpay.msgSrcId = detail.setting.msgSrcId;
              this.form.unionpay.Key = detail.setting.Key;
            }
            if (this.form.payment_type == '100-ini') {
              this.form.ini.key = detail.setting.key;
              this.form.ini.api_app_id = detail.setting.api_app_id;
              this.form.ini.app_id = detail.setting.app_id;
              this.form.ini.website = detail.setting.website;
            }
            if (['60-huifu_alipay_h5', '60-huifu_wxmp', '60-huifu_alipay_app','60-huifu_wxmn'].indexOf(this.form.payment_type) > -1 ) {
              this.form.adapay.app_id = detail.setting.app_id;
              this.form.adapay.pay_channel = detail.setting.pay_channel;
            }
          })
          .catch(error => {

          });
      },

      //提交表单
      onSubmit() {
        let self = this;
        let form = {};
        form = Object.assign(form, this.form);
        let paymentType = form.payment_type.split("-");
        form.value = paymentType[0];
        form.payment_type = paymentType[1];
        form.label = paymentType[1];
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.editPayment(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，添加成功',
                  type: 'success'
                });
                 self.$router.push('/setting/payment/index');

              }).catch(error => {
                self.loading = false;
              });
          }
        });
      },

      /*选择图片*/
      chooseImg(){
        this.isupload=true;
      },

      /*关闭选择图片*/
      returnImgsFunc(e){
        this.isupload=false;
        this.form.file_id = e[0].file_id;
        this.form.file_url = e[0].file_path;
      }

    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/payment/edit.vue